import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dudak-dolgusu-sonrasi-alkol-aliminin-sonuclari/page.tsx");
